module.exports = __webpack_public_path__ + "img/home-icon-4-3.735be630.png";